<fc-general-modal [baseId]="baseId" [form]="form" [fcModalItemContext]="fcModalItemContext" (saveForm)="save()"
  (cancelForm)="onCancel()">
  <div [formGroup]="form">
    <!-- External Id Control -->
    <div class="form-group">
      <label for="{{ baseId }}-id" translate>ID</label>
      <input id="{{ baseId }}-id" class="form-control"
        [ngClass]="{ error: showErrors(externalIdControl, isSubmitted),'required': isRequired(externalIdControl) }"
        type="text" [maxlength]="fcListValidation.validations.ExternalID.MaxLength" formControlName="externalId" />
      <div *ngIf="showErrors(externalIdControl, isSubmitted)" class="incorrect-input" id="{{ baseId }}-warning-text-id"
        translate>
        {{ externalIdControl.errors | fcListValidation : 'ID' }}
      </div>
    </div>
    <!-- External Id Control -->

    <!-- Name Control -->
    <div class="form-group">
      <label for="{{ baseId }}-name" translate>Name</label>
      <div class="required">
        <input id="{{ baseId }}-name" class="form-control"
          [ngClass]="{ error: showErrors(nameControl, isSubmitted), 'required': isRequired(nameControl) }" type="text"
          [maxlength]="fcListValidation.validations.Name.MaxLength" formControlName="name" />
      </div>
      <div *ngIf="showErrors(nameControl, isSubmitted)" class="incorrect-input" id="{{ baseId }}-warning-text-name"
        translate>
        {{ nameControl.errors | fcListValidation : 'Name' }}
      </div>
    </div>
    <!-- Name Control -->

    <!-- message type Control -->
    <div class="filter-find-control base-row appointment-type-filter">
      <label class="message-type-label">Message Type</label>
      <ap-findcontrol [singleSelect]="'true'" [findControlId]="'ListMessageType'" [baseId]="baseId + '-type'"
      [controlName]="MessageTypeUidControl"  [findControlDisplayName]="'Find Message type'" (chipsChange)="onMessageTypeSelected($event)">
      </ap-findcontrol>
    </div>
    <!-- messageType Control -->


    <!-- Notes Control -->
    <div class="form-group full-control">
      <label for="{{ baseId }}-notes" translate>Notes</label>
      <textarea class="form-control"
        [ngClass]="{ error: showErrors(notesControl, isSubmitted), 'required': isRequired(notesControl) }"
        id="{{ baseId }}-notes" formControlName="notes" [maxlength]="fcListValidation.validations.Notes.MaxLength"
        rows="3">
        </textarea>
      <div *ngIf="showErrors(notesControl, isSubmitted)" class="incorrect-input" id="{{ baseId }}-warning-text-notes"
        translate>
        {{ notesControl.errors | fcListValidation : 'Notes' }}
      </div>
    </div>
    <!-- Notes Control -->

    <!-- Inactive, User Defined and SMS Enabled checkboxes -->
    <div class="checkbox-group">
      <mat-checkbox id="{{ baseId }}-inactive-checkbox" formControlName="inactive" translate>Inactive</mat-checkbox>
      <mat-checkbox id="{{ baseId }}-user-defined-checkbox" formControlName="userDefined" translate>User
        Defined</mat-checkbox>
    </div>
    <!-- Inactive, User Defined and SMS Enabled checkboxes -->
  </div>
</fc-general-modal>